export * from './text-info';
